<template>
  <div id="contents-container">
    <div class="article-wrapper">
      <div class="category">
        <h2 class="pa-1">{{ boardCategory }}</h2>
        <hr />
      </div>
      <div class="article-container">
        <div class="article-header">
          <div class="left">
            <dl>
              <dt>글번호:</dt>
              <dd>{{ boardNumber }}</dd>
            </dl>
          </div>
          <div class="right">
            <dl>
              <dt>작성일:</dt>
              <dd>{{ boardUpdateDate }}</dd>
            </dl>
            <dl>
              <dt>작성자:</dt>
              <dd>{{ boardWriter }}</dd>
            </dl>
            <dl>
              <dt>조회수:</dt>
              <dd>{{ contents.hit }}</dd>
            </dl>
          </div>
        </div>
        <h2>
          <span v-if="contents.notice" class="notice">공지</span
          >{{ contents.title }}
        </h2>
        <div class="article" v-html="contents.content"></div>
        <div class="attached">
          <dl class="label">
            <i class="fas fa-paperclip"></i>
            첨부파일
          </dl>
          <dd class="insert">
            <ul>
              <!-- <template v-for="file in contents.files">
                <li :key="file">
                  <a
                    :href="`${BASE_API_URL}/media/${file}`"
                    id="downloader"
                  >
                    {{file}} </a
                  ><i
                    class="fas fa-save pl-2 download-icon"
                    @click="download(file)"
                  ></i>
                </li>
              </template> -->
              <template v-if="!!edufile">
                <li>
                  <a id="downloader" href="#" @click="download(edufile)">
                    {{ edufile }} <i class="fas fa-save pl-2 download-icon"></i
                  ></a>
                </li>
              </template>
            </ul>
          </dd>
        </div>
        <!-- <div>
          <v-btn
            class="mt-5 mb-5 btn-back"
            min-width="50px"
            min-height="50px"
            elevation="0"
            @click="$router.push({path:`/board/${id}/contents/${bid}/editor`})"
            v-if="isWriter"
          >
            수정
          </v-btn>
        </div> -->
        <div>
          <v-btn
            class="mt-5 mb-5"
            min-width="50px"
            min-height="50px"
            elevation="0"
            @click="
              $router.push({
                path: `/board/${$route.params.id}/contents/${$route.params.bid}/editor`
              })
            "
            v-if="isWriter"
          >
            수정
          </v-btn>
          <v-btn
            class="mt-5 mb-5"
            min-width="50px"
            min-height="50px"
            elevation="0"
            @click="remove"
            v-if="isWriter"
          >
            삭제
          </v-btn>
          <v-btn
            class="mt-5 mb-5 btn-back"
            min-width="50px"
            min-height="50px"
            elevation="0"
            @click="$router.go(-1)"
          >
            목록
          </v-btn>
        </div>
      </div>
    </div>
    <div class="comment-box" v-if="isAuth">
      댓글 <span>{{ comments.length }}</span> 개
      <div>
        <v-textarea
          outlined
          auto-grow
          rows="1"
          row-height="15"
          name="input-7-4"
          label="댓글을 입력해주세요."
          value=""
          v-model="comment"
        ></v-textarea>
        <v-btn
          class="comment-btn"
          color="primary"
          elevation="3"
          large
          @click="createComment()"
          >등록</v-btn
        >
      </div>
      <br />
      <template v-for="(data, i) in comments">
        <div :key="i" class="comment-data">
          <div class="comment-title">{{ data.writer }}</div>
          <div class="comment-content">{{ data.comment }}</div>
          <div class="comment-date">{{ getCommentDate(data.created_at) }}</div>
          <v-btn
            v-if="getUser.email === data.writer"
            @click="removeComment(data.id)"
            >삭제</v-btn
          >
          <Reply
            :key="i"
            :data="data"
            :board_id="id"
            :type="type"
            @replySuccess="replySuccess"
            @replyDelete="replyDelete"
          ></Reply>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Reply from "../../../components/utils/common/Reply.vue";
import { mapGetters } from "vuex";
import { BASE_API_URL } from "../../../store/api";

const instance = axios.create({
  baseURL: BASE_API_URL
});

export default {
  components: {
    Reply
  },
  data() {
    return {
      contents: "",
      // category: ['Q & A', '교육자료', '', '포토게시판'],
      // types: ['qna', 'data', '', 'photo'],
      category: ["Q & A", "공지사항", "교육자료", "Q & A"],
      types: ["qna", "photo", "data", "qna"],
      type: -1,
      id: -1,
      files: [],
      edufile: "",
      comment: "",
      comments: []
    };
  },
  mounted() {
    this.id = this.$route.params.bid;
    this.type = this.types[this.$route.params.id];
    this.fetchBoardContents(this.id, this.type);
  },
  computed: {
    ...mapGetters("auth", ["isAuth", "getUser"]),
    /**
     * 해당 유저가 작성자인지 아닌지 확인
     * @returns {boolean} true or false 반환
     */
    isWriter() {
      if (!this.getUser) return false;
      return this.getUser.email === this.contents.writer;
    },
    /**
     * 글 작성자의 email에서 @ 의 앞부분만 잘라서 반환
     * @returns {string} 글 작성자의 email에서 @ 의 앞부분만 잘라서 반환
     */
    boardWriter() {
      if (!this.contents.writer) return "";
      return this.contents.writer.substring(
        0,
        this.contents.writer.indexOf("@")
      );
    },
    /**
     * 글 번호를 무조건 4자리수로 맞춰서 반환
     * @returns {string} 4자리수로 정렬된 글번호
     */
    boardNumber() {
      return this.id.toString().padStart(4, "0");
    },
    /**
     * 어떤 카테고리에 있는지 보여줌
     * @returns {string} 해당 글의 카테고리를 반환
     */
    boardCategory() {
      return this.category[this.$route.params.id];
    },
    /**
     * 글의 업데이트 날짜를 계산
     * @returns {string} 글이 있다면 날짜를 반환 없으면 빈 문자열 반환
     */
    boardUpdateDate() {
      let date = "";
      if (this.contents) {
        const _date = this.contents.update.toString().substring(0, 10);
        const _time = this.contents.update.toString().substring(11, 16);
        date = _date + " " + _time;
      }
      return date;
    }
  },
  methods: {
    /**
     * 페이지가 마운트 되었을때 글의 상세 내용, 해당 글의 댓글을 서버에서 가져옴
     * @param {string} id 현재 글의 id
     * @param {string} type 현재 어떤 자료실에 있는지 판별
     * @returns {undefined} 아무것도 반환하지 않음
     */
    fetchBoardContents(id, type) {
      instance
        .get(`/edu/${type}/${id}`)
        .then(res => {
          this.contents = res.data;
          let _edufile = res.data.edufile;
          let _edufilestrs = _edufile.split("/");
          if (_edufilestrs.length)
            this.edufile = _edufilestrs[_edufilestrs.length - 1];
        })
        .catch(err => {
          console.error("fetchBoardContents", err);
        });
      if (this.isAuth) this.fetchBoardComments(id, type);
    },
    fetchBoardComments(id, type) {
      instance
        .get(`/edu/${type}/${id}/comments`)
        .then(res => {
          this.comments = res.data;
        })
        .catch(err => {
          console.error("fetchBoardComments", err);
        });
    },
    /**
     * 글 삭제 기능
     * @returns {undefined} 아무것도 반환하지 않음
     */
    remove() {
      axios
        .delete(`/edu/${this.type}/${this.id}`)
        .then(res => {
          window.alert("삭제되었습니다.");
          this.$router.go(-1);
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 댓글의 날짜를 일정하게 바꿔줌
     * @param {string} arg datetime 문자열
     * @returns {string} 받은 문자열을 정렬해서 반환
     */
    getCommentDate(arg) {
      const date = arg.toString().substring(0, 10);
      const time = arg.toString().substring(11, 16);
      return date + " " + time;
    },
    /**
     * 댓글을 서버에 저장
     * 저장 후 글, 댓글 reload
     * @returns {undefined} 아무것도 반환하지 않음
     */
    createComment() {
      if (!this.comment) return window.alert("댓글을 입력해주세요.");
      instance
        .post(
          `/edu/${this.type}/${this.id}/comments/`,
          {
            id: this.getUser.pk,
            content: this.comment
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.$store.state.auth.access
            }
          }
        )
        .then(res => {
          window.alert("등록되었습니다.");
          this.fetchBoardContents(this.id, this.type);
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * id값에 해당하는 댓글 삭제
     * @param {string} id 삭제 버튼이 클릭된 댓글
     * @returns {undefined} 아무것도 반환하지 않음
     */
    removeComment(id) {
      instance
        .post(
          `/edu/${this.type}/${this.id}/comments/${id}/remove/`,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: this.$store.state.auth.access
            }
          }
        )
        .then(res => {
          window.alert("삭제되었습니다.");
          this.fetchBoardContents(this.id, this.type);
        })
        .catch(err => {
          console.log(err);
        });
    },
    /**
     * 대댓글 작성 확인 함수
     * component에서 완료 요청시 해당글, 댓글 reload
     * @returns {undefined} 아무것도 반환하지 않음
     */
    replySuccess() {
      window.alert("답글을 등록하였습니다.");
      this.fetchBoardContents(this.id, this.type);
    },
    /**
     * 대댓글 삭제 확인 함수
     * component에서 삭제 완료 요청시 해당글, 댓글 reload
     * @returns {undefined} 아무것도 반환하지 않음
     */
    replyDelete() {
      window.alert("답글을 삭제하였습니다");
      this.fetchBoardContents(this.id, this.type);
    },
    /**
     * 파일 다운로드 함수
     * @param {string} filename 파일의 경로
     * @returns {undefined} 아무것도 반환하지 않음
     */
    download(filename) {
      const url = instance.baseURL + `/media/${filename}`;
      // const req = new XMLHttpRequest();
      // req.open("GET", url, true);
      // req.responseType = "blob";
      // req.onload = event => {
      //   const blob = req.response;
      //   const link = document.createElement("a");
      //   link.href = window.URL.createObjectURL(blob);
      //   link.download = filename;
      //   link.click();
      // };
      // req.send();

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.click();
    }
  }
};
</script>

<style lang="scss" scoped>
#contents-container {
  width: 100%;
  padding: 30px 50px;
  margin: 0 auto;
  margin-bottom: 50px;
  .category {
    width: 200px;
    text-align: left;
    & > hr {
      width: 120px;
      margin-top: 0px;
      border: 2px solid #2156d0;
      background: #2156d0;
    }
  }
  .article-header {
    height: 35px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    dl,
    dt,
    dd {
      display: inline-block;
      font-size: 1.1rem;
    }
    dl {
      padding: 0px 12px;
      border-right: 1px solid #aaa;
    }
    dl:first-child {
      padding-left: 0px;
    }
    dl:last-child {
      border-right: none;
      padding-right: 0px;
    }
    dt {
      padding-right: 10px;
    }
  }
  .article-container {
    padding-top: 20px;
    & > h2 {
      border-top: 2.5px solid #444;
      padding: 15px 0px;
      text-align: center;
      background-color: #eee;
      .notice {
        font-size: 1.1rem;
        border: 2px solid #2156d0;
        padding: 3px 7px;
        border-radius: 5px;
        margin-right: 12px;
        color: #2156d0;
      }
    }
    .article {
      height: auto;
      padding: 30px 60px;
      .table td {
        border: 1px solid black;
      }
    }
    .attached {
      position: relative;
      border: 1px solid #ccc;
      border-top: 1px solid #444;
      padding: 5px 0px 5px 60px;
      display: flex;
      .label {
        font-weight: 600;
        color: #000;
        font-size: 1.2em;
        width: 160px;
        padding: 20px 0px;
        border: none;
      }
      .insert {
        padding: 10px;
        margin: auto;
      }
    }
    .btn-back {
      position: absolute;
      right: 170px;
      font-size: 1.2rem !important;
      border: 2px solid #9094a2;
      background-color: #9094a2;
      color: white;
    }
  }
  .download-icon:hover {
    cursor: pointer;
  }
  .comment-box {
    position: relative;
    margin-top: 80px;
    // border: solid black 1px;
    height: 100%;
    .comment {
      border: solid black 1px;
    }
    .comment-input {
      width: 100%;
      // height: 4vh;
    }
    .comment-data {
      border: 1px solid black;
    }
    .comment-reply {
      position: relative;
    }
  }
}
</style>
